/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RespondToLicensingSignInChallengeError = "CHALLENGERESPONSEFAILED" | "NEWPASSWORDINVALID" | "UNKNOWNCHALLENGETYPE" | "VALIDATIONERROR" | "%future added value";
export type RespondToLicensingNewPasswordRequiredSignInChallengeInput = {
    email: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    newPassword: string;
    session: string;
};
export type respondToNewPasswordRequiredChallengeMutationVariables = {
    input: RespondToLicensingNewPasswordRequiredSignInChallengeInput;
};
export type respondToNewPasswordRequiredChallengeMutationResponse = {
    readonly respondToNewPasswordRequiredLicensingSignInChallenge: {
        readonly wasSuccessful: boolean;
        readonly jwtToken: string | null;
        readonly error: RespondToLicensingSignInChallengeError | null;
    } | null;
};
export type respondToNewPasswordRequiredChallengeMutation = {
    readonly response: respondToNewPasswordRequiredChallengeMutationResponse;
    readonly variables: respondToNewPasswordRequiredChallengeMutationVariables;
};



/*
mutation respondToNewPasswordRequiredChallengeMutation(
  $input: RespondToLicensingNewPasswordRequiredSignInChallengeInput!
) {
  respondToNewPasswordRequiredLicensingSignInChallenge(input: $input) {
    wasSuccessful
    jwtToken
    error
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RespondToLicensingNewPasswordRequiredSignInChallenge",
            "kind": "LinkedField",
            "name": "respondToNewPasswordRequiredLicensingSignInChallenge",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jwtToken",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "error",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "respondToNewPasswordRequiredChallengeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "respondToNewPasswordRequiredChallengeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "876fe201bf8ce6b37520a32df077080a",
            "id": null,
            "metadata": {},
            "name": "respondToNewPasswordRequiredChallengeMutation",
            "operationKind": "mutation",
            "text": "mutation respondToNewPasswordRequiredChallengeMutation(\n  $input: RespondToLicensingNewPasswordRequiredSignInChallengeInput!\n) {\n  respondToNewPasswordRequiredLicensingSignInChallenge(input: $input) {\n    wasSuccessful\n    jwtToken\n    error\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '728e474c51ae3c8c94457dba6b801ce0';
export default node;
